module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-38.0c7734e9.png";